import { createSlice } from '@reduxjs/toolkit';

const ProfitabilityAnalysisSlice = createSlice({
  name: 'ProfitabilityAnalysisSlice',
  initialState: {
    isLoading: false,
    fieldValidationError: null,
    isError: null,
    profitabilityGrossRevenueGraphData: [],
  },
  reducers: {
    //////// Profitability Analysis Gross revenue graph //////////
    requestProfitabilityGrossRevenueGraph: (state) => {
      return { ...state, isLoading: true };
    },
    responseProfitabilityGrossRevenueGraph: (state, action) => {
      return {
        ...state,
        isLoading: false,
        profitabilityGrossRevenueGraphData: action?.payload?.data,
        fieldValidationError: null,
      };
    },
    failureProfitabilityGrossRevenueGraph: (state, action) => {
      return {
        ...state,
        isLoading: false,
        isError: action?.payload,
        fieldValidationError: action?.payload,
      };
    },
  },
});

export const {
  failureProfitabilityGrossRevenueGraph,
  requestProfitabilityGrossRevenueGraph,
  responseProfitabilityGrossRevenueGraph,
} = ProfitabilityAnalysisSlice.actions;
export default ProfitabilityAnalysisSlice.reducer;
